import { render, staticRenderFns } from "./EditAttachedFiles.modal.vue?vue&type=template&id=59a16488&scoped=true&"
import script from "./EditAttachedFiles.modal.vue?vue&type=script&lang=js&"
export * from "./EditAttachedFiles.modal.vue?vue&type=script&lang=js&"
import style0 from "./EditAttachedFiles.modal.vue?vue&type=style&index=0&id=59a16488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a16488",
  null
  
)

export default component.exports